export const ADDITIONAL_GUEST_SEATS = 5
